// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__g1meG","spinner":"Spinner_spinner__H2HDD","spin":"Spinner_spin__DSOqJ"};